import { Component, OnInit, Input } from "@angular/core";
import { Observable, of } from "rxjs";
import { NumberFormatStyle } from "@angular/common";
interface Shape {
  iterations: number;
  expand: number;
  angle: number;
}

@Component({
  selector: "artbycoloring-canvas",
  templateUrl: "./canvas.component.html",
  styleUrls: ["./canvas.component.css"],
})

export class CanvasComponent implements OnInit {

  event: MouseEvent;
  clientX = 0;
  clientY = 0;

  onEvent(event: MouseEvent): void {
    this.event = event;
  }

  coordinates(event: MouseEvent): void {
    this.clientX = event.clientX;
    this.clientY = event.clientY;
  }
  @Input()

  myend: string;
  all: number[];
  alpha: number;
  alphap: string;
  amove: string;
  amoveh: number;
  amovehString: string;
  amovehValue: number;
  amovev: number;
  amovevString: string;
  amovevValue: number;
  amovex: string;
  amovey: string;
  animate: string;
  animateRotate: boolean;
  animateScale: boolean;
  animateScaleX: boolean;
  animateScaleY: boolean;
  animateSkewX: boolean;
  animateSkewY: boolean;
  animateStage1: boolean;
  animateStage2: boolean;
  animateTranslateh: boolean;
  animateTranslatev: boolean;
  arot: string;
  arotate: number;
  arotateString: string;
  arotateValue: number;
  Arr = Array; //Array type captured in a variable
  artData: string;
  artplace: string;
  ascale: string;
  ascaleit: number;
  ascaleitString: string;
  ascaleitValue: number;
  ascaleX: number;
  ascalex: string;
  ascaleXString: string;
  ascaleXValue: number;
  ascaleY: number;
  ascaley: string;
  ascaleYString: string;
  ascaleYValue: number;
  askewX: number;
  askewx: string;
  askewXString: string;
  askewXValue: number;
  askewY: number;
  askewy: string;
  askewYString: string;
  askewYValue: number;
  astart: string;
  atype: string;
  avalues: string;
  backg: number;
  backgAlpha: Number;
  backgColorString: string;
  backgHue: Number;
  backgSat: Number;
  backgVal: Number;
  baseanimate: string;
  basement: string;
  basemoveh: any;
  basemovev: any;
  baserotate: any;
  basescale: any;
  basescaleX: any;
  basescaleY: any;
  baseskewX: any;
  baseskewY: any;
  baseuse: boolean;
  centx: number;
  centy: number;
  changeit: any;
  click: boolean
  clickX: number;
  clickY: number;
  colorNumber: number;
  colors: any;
  colorString: any;
  counter: number;
  cskax: number;
  cskay: number;
  currentColor: String;
  currentFill: String;
  cx: number;
  cy: number;
  layers: number;
  direction: String;
  default: number;
  deltak: number;
  deltal: number;
  deltam: number;
  doanimate: string;
  duplicateShape: boolean;
  durspeed: number;
  file: any;
  filenamein: string;
  filenameout: string;
  fileShape: string = "fileShape";
  fillColorString: string;
  hue: number;
  huep: string;
  ianimate: number;
  i: any;
  iexpand: number;
  ignoreShape: boolean;
  inone: Number;
  imoveh: number;
  imovehString: string;
  imovehValue: number;
  imovev: number;
  imovevString: string;
  imovevValue: number;
  irock: number;
  irotate: number;
  irotateString: string;
  irotateValue: number;
  iscale: number;
  iscaleit: number;
  iscaleitString: string;
  iscaleitValue: number;
  iscaleString: string;
  iscaleValue: number;
  iscaleX: number;
  iscaleXString: string;
  iscaleXValue: number;
  iscaleY: number;
  iscaleYString: string;
  iscaleYValue: number;
  iskewX: number;
  iskewXString: string;
  iskewXValue: number;
  iskewY: number;
  iskewYString: string;
  iskewYValue: number;
  item: string;
  kitchen: string;
  lastMoveX: number;
  lastMoveY: number;
  lockzoom: boolean;
  maxx: number;
  maxy: number;
  middys: string;
  minx: number;
  miny: number;
  modifyit: Array<number>;
  moveShape: boolean;
  moveX: number;
  moveY: number;
  myboundinbgbox: string;
  mybox: HTMLElement;
  mycenter: string;
  mycentered: string;
  mycolor: string;
  mydisplay: string;
  mygroup: boolean;
  mymirror: string;
  mynum: number;
  mypoly: string;
  myscalex: boolean;
  myscaley: boolean;
  myshape: any;
  mysvgfile: string;
  newbase: string;
  newDemo: string;
  newProject: string;
  newShape: string = "newShape";
  nlength: number;
  numberShapes: number;
  numpnt: string;
  objectData: string;
  offset: any;
  outbase: any;
  outdata: string;
  outputSpreadString: string;
  paletteColor: string;
  paletteString: string;
  part1: string;
  part2: string;
  partslength: number;
  partsString: string[];
  partsValue: number[];
  pastePaletteString: string;
  pasteArtDataString: string;
  pasteSVGcodeString: string;
  playspace: any;
  plength: number;
  polyShape: string = "polyShape";
  presetsbox: boolean;
  randomAlphaValue: boolean;
  randomColor: boolean;
  randomHueValue: boolean;
  randomHValue: boolean;
  randomRotateValue: boolean;
  randomSatValue: boolean;
  randomScaleValue: boolean;
  randomSkewXValue: boolean;
  randomSkewYValue: boolean;
  randomString: string;
  randomStrokeColorValue: boolean;
  randomStrokeWidthValue: boolean;
  randomValValue: boolean;
  randomVValue: boolean;
  re: any
  rememberArtData: string;
  rgbColor: string;
  rorx: number;
  rory: number;
  rotateString: string;
  rotateValue: number;
  sat: number;
  satp: string;
  scale: number;
  scaleString: string;
  selectedColor: any;
  selectedElement: boolean;
  selectedMyElement: any;
  shape: string;
  shapecode: string;
  shapeArray = Array;
  shapeID: string;
  shapeName: string = "#shape";
  shapes: Observable<Shape[]>;
  shapeData: string;
  showArtData: boolean = false;
  showData: string;
  showShape: boolean = false;
  skax: number;
  skay: number;
  skewXString: string;
  skewXValue: number;
  skewYString: string;
  skewYValue: number;
  spreadsize: number;
  sskax: number;
  sskay: number;
  stageHalf: number;
  stageSize: number;
  stroke: number;
  strokeAlpha: Number;
  strokeColorString: string;
  strokeHue: Number;
  strokeSat: Number;
  strokeString: string;
  strokeVal: Number;
  strokeWidth: Number;
  strokeWidthString: string;
  svg: any;
  svgheight: string;
  svgstage: string;
  svgviewbox: string;
  svgwidtth: string;
  svgx: string;
  svgy: string;
  thing: string;
  tom: any;
  transform: any;
  transformString: string;
  translateHValue: number;
  translateString: string;
  translateVValue: number;
  tskax: number;
  tskay: number;
  usechallenge: boolean;
  usepalettebox: boolean;
  val: number;
  valp: string;
  xlist: number[];
  xx: number[];
  ylist: number[];
  yourname: string;
  yy: number[];
  zoomsize: Number;

  constructor() { }

  ngOnInit() {
    var mybox = document.getElementById("playspace");
    mybox.addEventListener("click", this.polyit);



    this.shapes = of([
      {
        id: 1,
        iterations: 18,
        angle: 15,
        expand: 47
      },
      {
        id: 2,
        iterations: 36,
        angle: 11,
        expand: 33
      }
    ]);


    this.setValues();
    this.svgstage = this.convertStageSize(this.stageSize);
    this.selectedColor = {
      r: 100,
      g: 130,
      b: 150,
      a: this.alpha
    };
  }

  private setValues() {
    this.myend = 'dur="' + this.durspeed + '" repeatCount="indefinite" additive="sum"/>';
    this.all = [this.irotate, this.iscaleX, this.iscaleY, this.iskewX, this.iskewY, this.imoveh, this.imovev];
    this.alpha = 1;
    this.alphap = "1";
    this.amove;
    this.amoveh = 100;
    this.amovehString = "100";
    this.amovehValue = 100;
    this.amovev = 100;
    this.amovevString = "100";
    this.amovevValue = 100;
    this.amovex;
    this.amovey;
    this.animate = '<polygone points="0,0 200.0 0,20>';
    this.animateRotate = false;
    this.animateScale = false;
    this.animateScaleX = false;
    this.animateScaleY = false;
    this.animateSkewX = false;
    this.animateSkewY = false;
    this.animateStage1 = false;
    this.animateStage2 = false;
    this.animateTranslateh = false;
    this.animateTranslatev = false;
    this.arot = "";
    this.arot;
    this.arotate = 360;
    this.arotateString = "360";
    this.arotateValue = 360;
    this.artData = "";
    this.artplace = "";
    this.ascale;
    this.ascaleit = 0;
    this.ascaleitString = "0";
    this.ascaleitValue = 0;
    this.ascaleX = 0.9;
    this.ascalex;
    this.ascaleXString = "0.9";
    this.ascaleXValue = 0.9;
    this.ascaleY = 0.9;
    this.ascaley;
    this.ascaleYString = "0.9";
    this.ascaleYValue = 0.9;
    this.askewX = 20;
    this.askewx;
    this.askewXString = "20";
    this.askewXValue = 20;
    this.askewY = 20;
    this.askewy;
    this.askewYString = "20";
    this.askewYValue = 20;
    this.astart = '<animateTransform id="myanimation" attributeName="transform" attributeType="XML" type=';
    this.atype = "rotate";
    this.avalues = "0\;360";
    this.backg = 0;
    this.backgAlpha = 1;
    this.backgHue = 360;
    this.backgSat = 100;
    this.backgVal = 100;
    this.baseanimate = '<polygone points="0,0 200.0 0,20>';
    this.basement = '<path points="M0,0 L100,100 l100,0z>';
    this.basemoveh = 0;
    this.basemovev = 0;
    this.baserotate = 0;
    this.basescale = 1;
    this.basescaleX = 1;
    this.basescaleY = 1;
    this.baseskewX = 0;
    this.baseskewY = 0;
    this.baseuse = false;
    this.centx = 0;
    this.centy = 0;
    this.click = false;
    this.clickX = 0;
    this.clickY = 0;
    this.colorNumber = 0;
    this.colors = Array;
    this.colorString = Array;
    this.counter = 0;
    this.cskax = 0;
    this.cskay = 0;
    this.currentColor = "#F0F0F0FF";
    this.currentFill = "";
    this.cx = 0;
    this.cy = 0;
    this.layers = 60;
    this.direction = "";
    this.default = 1;
    this.deltak = 1;
    this.deltal = 1;
    this.deltam = 1;
    this.doanimate = "";
    this.duplicateShape = false;
    this.durspeed = 20;
    this.filenamein = "art.txt";
    this.filenameout = "art.txt";
    this.hue = 10;
    this.huep = "0";
    this.iexpand = 4;
    this.ignoreShape = false;
    this.inone = 0;
    this.imoveh = 100;
    this.imovehString = "100";
    this.imovehValue = 100;
    this.imovev = 100;
    this.imovevString = "100";
    this.imovevValue = 100;
    this.irotate = 45;
    this.irotateString = "360";
    this.irotateValue = 360;
    this.iscale = 3;
    this.iscaleString = "0";
    this.iscaleValue = 0;
    this.iscaleX = 0.8;
    this.iscaleXString = "0.9";
    this.iscaleXValue = 0.9;
    this.iscaleY = 0.8;
    this.iscaleYString = "0.9";
    this.iscaleYValue = 0.9;
    this.iskewX = 30;
    this.iskewXString = "20";
    this.iskewXValue = 20;
    this.iskewY = 30;
    this.iskewYString = "20";
    this.iskewYValue = 20;
    this.item = "";
    this.lastMoveX = 0;
    this.lastMoveY = 0;
    this.maxx = 0;
    this.maxy = 0;
    this.middys = "";
    this.minx = 0;
    this.miny = 0;
    this.moveShape = true;
    this.moveX = 0;
    this.moveY = 0;
    this.myboundinbgbox = "";
    this.mycenter = "";
    this.mycentered = "";
    this.mycolor = "";
    this.mydisplay = "";
    this.mygroup = false;
    this.mymirror = "";
    this.mynum = 0;
    this.mypoly = "";
    this.myscalex = false;
    this.myscaley = false;
    this.myshape = "<line 0,0 700,700 />";
    this.mysvgfile = "";
    this.newbase = "";
    this.newDemo = "demoDemo";
    this.nlength = 0;
    this.numberShapes = 2;
    this.numpnt = "";
    this.objectData = "";
    this.offset = 0;
    this.outdata = "";
    this.outputSpreadString = "rotate(0,0,0) scale(1,1) skewX(0) skewY(0) translate(0,0)";
    this.paletteColor = "10,100,100,1";
    this.paletteString = "";
    this.part1 = "";
    this.part2 = "";
    this.partslength = 0;
    this.partsString = [];
    this.partsValue = [];
    this.pastePaletteString = "";
    this.pasteArtDataString = "";
    this.pasteSVGcodeString = "";
    this.playspace = "";
    this.plength = 3;
    this.presetsbox = false;
    this.randomAlphaValue = false;
    this.randomColor = false;
    this.randomHueValue = false;
    this.randomHValue = false;
    this.randomRotateValue = false;
    this.randomSatValue = false;
    this.randomScaleValue = false;
    this.randomSkewXValue = false;
    this.randomSkewYValue = false;
    this.randomStrokeColorValue = false;
    this.randomStrokeWidthValue = false;
    this.randomValValue = false;
    this.randomVValue = false;
    this.re = "";
    this.rememberArtData = "";
    this.rorx = 0;
    this.rory = 0;
    this.rotateValue = 5;
    this.sat = 100;
    this.satp = "100";
    this.scale = 1.5;
    this.selectedElement = false;
    this.selectedMyElement = null;
    this.kitchen = "";
    this.shapeArray = Array;
    this.shapecode = "<>";
    this.shapeData = ""
    this.shapeID = "shape";
    this.shapeName = "#shape";
    this.showData = "";
    this.skax = 0;
    this.skay = 0;
    this.skewXValue = 0;
    this.skewYValue = 0;
    this.spreadsize = 200;
    this.sskax = 0;
    this.sskay = 0;
    this.stageHalf = -250;
    this.stageSize = 500;
    this.stroke = 0;
    this.strokeAlpha = 1;
    this.strokeHue = 0;
    this.strokeSat = 100;
    this.strokeVal = 100;
    this.strokeWidth = 5;
    this.svgheight = 'height="1000px"';
    this.svg = null;
    this.svgstage = "";
    this.svgviewbox = 'viewBox="-500 -500 1000 1000"';
    this.svgwidtth = 'width="500px"';
    this.svgx = 'x="-500px"';
    this.svgy = 'y="-500px"';
    this.thing = "";
    this.thing = "";
    this.transform = null;
    this.translateHValue = 0;
    this.translateVValue = 0;
    this.tskax = 0;
    this.tskay = 0;
    this.usechallenge = false;
    this.usepalettebox = false;
    this.val = 100;
    this.valp = "100";
    this.xlist = [];
    this.xx = [];
    this.ylist = [];
    this.yourname = "yourname";
    this.yy = [];
    this.zoomsize = 60;
  }

  private setShape(shapeName) {
    this.shapeName = shapeName;
    this.shapeID = this.shapeName.replace(/#/, "");
    //this.shapeID = setShape(shapeName);
    return this.shapeID;
  }

  private setNumberShapes(numberShapesValue) {
    this.numberShapes = numberShapesValue;
  }

  private outputTransform(
    rotate,
    r,
    randomRotateValue,
    scale,
    s,
    randomScaleValue,
    skewX,
    sx,
    randomSkewXValue,
    skewY,
    sy,
    randomSkewYValue,
    translate,
    th,
    randomHValue,
    tv,
    randomVValue,
    i
  ) {
    if (rotate == "rotate") {
      if (this.randomRotateValue == true) {
        r = this.getRandom(1, 360);
      }
      this.rotateString = "rotate(" + r + ",0,0)";
    }
    if (scale == "scale") {
      if (this.randomScaleValue == true) {
        s = this.getRandom(1, 200) / 360;
      }
      s = s.toFixed(2);
      if (this.myscalex === true) {
        this.scaleString = "scale(" + s + ", 1)";
      }
      else if (this.myscaley === true) {
        this.scaleString = "scale(1, " + s + ")";
      }
      else {
        this.scaleString = "scale(" + s + ", " + s + ")";
      }
    }
    if (skewX == "skewX") {
      if (this.randomSkewXValue == true) {
        sx = this.getRandom(1, 80);
      }
      this.skewXString = "skewX(" + sx + ")";
    }
    if (skewY == "skewY") {
      if (this.randomSkewYValue == true) {
        sy = this.getRandom(1, 80);
      }
      this.skewYString = "skewY(" + sy + ")";
    }
    if (translate == "translate") {
      if (randomHValue == true) {
        th = this.getRandom(-900, 900);
      }
      if (randomVValue == true) {
        tv = this.getRandom(-900, 900);
      }
      this.translateString = "translate(" + th + "," + tv + ")";
    }
    this.transformString =
      this.rotateString +
      " " +
      this.scaleString +
      " " +
      this.skewXString +
      " " +
      this.skewYString +
      " " +
      this.translateString;

    return this.transformString;
  }

  private outputSpread(rotateValue, spreadsize) {
    this.outputSpreadString =
      "rotate(" +
      rotateValue +
      ",0,0) scale(1,1) skewX(0) skewY(0) translate(" +
      spreadsize +
      ",-" +
      spreadsize +
      ")";
    return this.outputSpreadString;
  }

  private hueWithWhite2rgba(otherHue) {
    if (otherHue <= 10) {
      this.strokeSat = 100;
      this.strokeVal = 0;
      this.strokeAlpha = 1;
    } else if (otherHue >= 350) {
      this.strokeSat = 0;
      this.strokeVal = 100;
      this.strokeAlpha = 1;
    } else {
      this.strokeSat = 100;
      this.strokeVal = 100;
      this.strokeAlpha = 1;
    }
    this.strokeColorString = this.hsv2rgba(
      otherHue,
      this.strokeSat,
      this.strokeVal,
      this.strokeAlpha
    );
    return this.strokeColorString;
  }

  private strokeWithWhite2rgba(stroke) {
    if (this.randomStrokeColorValue == true) {
      stroke = this.getRandom(10, 365);
    }
    if (stroke <= 10) {
      this.strokeSat = 100;
      this.strokeVal = 0;
      this.strokeAlpha = 1;
    } else if (stroke >= 350) {
      this.strokeSat = 0;
      this.strokeVal = 100;
      this.strokeAlpha = 1;
    } else {
      this.strokeSat = 100;
      this.strokeVal = 100;
      this.strokeAlpha = 1;
    }
    this.strokeColorString = this.hsv2rgba(
      stroke,
      this.strokeSat,
      this.strokeVal,
      this.strokeAlpha
    );
    return this.strokeColorString;
  }

  private backgWithWhite2rgba(backgHue) {
    if (backgHue <= 10) {
      this.backgSat = 100;
      this.backgVal = 0;
      this.backgAlpha = 1;
    } else if (backgHue >= 350) {
      this.backgSat = 0;
      this.backgVal = 100;
      this.backgAlpha = 1;
    } else {
      this.backgSat = 100;
      this.backgVal = 100;
      this.backgAlpha = 1;
    }
    this.backgColorString = this.hsv2rgba(
      backgHue,
      this.backgSat,
      this.backgVal,
      this.backgAlpha
    );
    return this.backgColorString;
  }

  private fillWithWhite2rgba(hue, sat, val, alpha) {
    this.counter++;
    //hue = hue % 360;
    if (this.randomHueValue == true) {
      hue = this.getRandom(0, 360);
    }
    if (this.randomSatValue == true) {
      sat = this.getRandom(0, 100);
    }
    if (this.randomValValue == true) {
      val = this.getRandom(20, 100);
    }
    if (this.randomAlphaValue == true) {
      alpha = this.getRandom(10, 100) / 100;
    }
    this.currentColor = hue + "," + sat + "," + val + "," + alpha;
    this.rgbColor = this.hsv2rgba(hue, sat, val, alpha);
    this.currentFill = this.rgbColor;
    if (this.usepalettebox == true) {
      this.rgbColor = this.nextColor(hue, sat, val, alpha);
    }
    return this.rgbColor;
  }

  private hsv2rgba(h, s, v, alpha) {
    var r;
    var g;
    var b;
    var i;
    var f;
    var p;
    var q;
    var t;
    var myflag;
    h = h / 360;
    s = s / 100;
    v = v / 100;
    //############
    i = Math.floor(h * 6);
    f = h * 6 - i;
    p = v * (1 - s);
    q = v * (1 - f * s);
    t = v * (1 - (1 - f) * s);
    //##############
    myflag = i % 6;
    //console.log(myflag);
    if (myflag == 0) {
      r = v;
      g = t;
      b = p;
    } else if (myflag == 1) {
      r = q;
      g = v;
      b = p;
    } else if (myflag == 2) {
      r = p;
      g = v;
      b = t;
    } else if (myflag == 3) {
      r = p;
      g = q;
      b = v;
    } else if (myflag == 4) {
      r = t;
      g = p;
      b = v;
    } else if (myflag == 5) {
      r = v;
      g = p;
      b = q;
    }
    r = r * 255;
    g = g * 255;
    b = b * 255;
    r = Math.round(r);
    g = Math.round(g);
    b = Math.round(b);
    this.rgbColor = "rgba(" + r + "," + g + "," + b + "," + alpha + ")";
    return this.rgbColor;
  }

  private getRandom(min, max) {
    var mynum = Math.random() * (max - min) + min;
    mynum = Math.floor(mynum);
    return mynum;
  }

  private downloadArt(id) {
    var svg = document.getElementById(id),
      xml = new XMLSerializer().serializeToString(svg),
      data = "data:image/svg+xml;base64," + btoa(xml),
      img = new Image();
    img.setAttribute("src", data);
    img.setAttribute("download", "image.svg");
    img.setAttribute("id", "myimage");
    var artplace = document.getElementById("art");
    artplace.appendChild(img);
    this.mysvgfile = String(img);
    console.log("mysvgfile \n" + this.mysvgfile);
  }

  private clearartarea() {
    var artplace = document.getElementById("art");
    var child = artplace.lastElementChild;
    while (child) {
      artplace.removeChild(child);
      child = artplace.lastElementChild;
    }
  }


  private pastesvgobject() {
    this.thing = "";
    this.pasteSVGcodeString = prompt("Paste SVG code here");
    if (this.pasteSVGcodeString == "") {
      this.pasteSVGcodeString = '<polygon points="168.364,-95.454 110.546,16.559 170.042,127.691 45.644,107.316 -41.663,198.242 -60.727,73.636 -174.181,18.7 -61.566,-37.936 -44.378,-162.813 44.287,-73.211"  stroke="black" stroke-width="5" />'
    }
    this.processsvgobject(this.pasteSVGcodeString);
  }

  private processsvgobject(artData) {
    this.artData = artData;
    this.re = /@/;
    if (this.artData.match(this.re)) {
      var info = this.artData.split("@");
      this.newProject = info[0];
      this.thing = info[1];
    }
    else {
      this.thing = this.artData;
    }
    this.setShape("#basement");
    this.shapeName = '#basement';
    document.getElementById("basement").innerHTML = this.thing;
    this.shapeData = this.thing;
    this.showData = "@" + this.shapeData;
    //alert("processsvg000 - thing - " + this.thing);
  }

  private polyit(event) {
    var myx = event.clientX;
    var myy = event.clientY;
    myx = myx - 675;
    myy = myy - 305;
    this.polyShape = document.getElementById("polyShape").innerHTML;
    this.polyShape = this.polyShape.replace(
      /"><\/polygon>/,
      myx + "," + myy + ' "></polygon>'
    );
    //console.log(this.polyShape);
    document.getElementById("polyShape").innerHTML = this.polyShape;
    //console.log(this.polyShape);
  }

  private mydownload(filename, text) {
    var element = document.createElement("a");
    element.setAttribute(
      "href",
      "data:text/plain;charset=utf-8," + encodeURIComponent(text)
    );
    element.setAttribute("download", filename);
    element.style.display = "none";
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  }

  private saveArtData() {
    this.artData =
      this.numberShapes +
      "_" +
      this.spreadsize +
      "_" +
      this.zoomsize +
      "_" +
      this.layers +
      "_" +
      this.rotateValue +
      "_" +
      this.scale +
      "_" +
      this.skewXValue +
      "_" +
      this.skewYValue +
      "_" +
      this.translateHValue +
      "_" +
      this.translateVValue +
      "_" +
      this.hue +
      "_" +
      this.sat +
      "_" +
      this.val +
      "_" +
      this.alpha +
      "_" +
      this.stroke +
      "_" +
      this.strokeWidth +
      "_" +
      this.backg +
      "_" +
      this.shapeName +
      "_" +
      this.randomRotateValue +
      "_" +
      this.randomScaleValue +
      "_" +
      this.randomSkewXValue +
      "_" +
      this.randomSkewYValue +
      "_" +
      this.randomHValue +
      "_" +
      this.randomVValue +
      "_" +
      this.randomHueValue +
      "_" +
      this.randomSatValue +
      "_" +
      this.randomValValue +
      "_" +
      this.randomAlphaValue +
      "_" +
      this.randomStrokeColorValue +
      "_" +
      this.randomStrokeWidthValue;
    this.filenameout = this.shapeName + "_artData.txt";
    this.filenameout = this.filenameout.replace(/#/, "");
    this.mydownload([this.filenameout], this.artData);
    console.log("this.artdata: " + this.outdata);
  }



  private savesvg(shapeName) {
    this.playspace = document.getElementById("box").innerHTML;
    var dataout = this.shapeID;
    dataout = dataout + "_shape.svg";
    this.mydownload([dataout], this.playspace);
  }

  private savesvgobject(shapeName) {
    if (this.shapeName === "#polyShape") {
      this.shapeData = document.getElementById("polyShape").innerHTML;
    } else if (this.shapeName === "#newShape") {
      this.shapeData = document.getElementById("newShape").innerHTML;
    } else if (this.shapeName === "#fileShape") {
      this.shapeData = document.getElementById("fileShape").innerHTML;
    } else if (this.shapeName === "#basement") {
      this.shapeData = document.getElementById("basement").innerHTML;
    } else if (this.shapeName === "#kitchen") {
      this.shapeData = document.getElementById("kitchen").innerHTML;
    } else {
      this.shapeID = this.setShape(this.shapeName);
      this.shapeData = document.getElementById(this.shapeID).innerHTML;
    }
    var dataout = this.shapeID;
    dataout = dataout + "_shape.svg";
    this.mydownload([dataout], this.shapeData);
  }

  private pasteArtData() {
    //prompt for artData
    this.pasteArtDataString = prompt("Paste artData Here:\n");
    if (this.pasteArtDataString == "") {
      this.pasteArtDataString = "3_200_20_168_5_0.23_0_0_0_0_10_100_100_1_0_5_0_#stick_false_false_false_false_false_false_false_false_false_false_false_false";
    }
    //alert("00 - pasteArtDataString- " + this.pasteArtDataString);
    this.re = /@/;
    if (this.pasteArtDataString.match(this.re)) {
      var info = this.pasteArtDataString.split("@");
      this.newProject = info[0];
      //alert("0 - newProject - " + this.newProject);
      this.thing = info[1];
      //alert("0 - thing - " + this.thing);
      this.processArtData(this.newProject);
      if (this.thing !== "") {
        //alert("1 - thing - " + this.thing);
        this.processsvgobject(this.thing)
      }
      else {
        this.processArtData(this.newProject);
      }
    }
    else {
      this.processArtData(this.pasteArtDataString);
    }
  }

  private processArtData(artData) {
    artData.replace(/\r\n/, "");
    this.artData = artData;
    this.artData = this.cleanThis(this.artData);
    if (this.artData.match(/@/)) {
      this.re = /@/;
      if (this.artData.match(this.re)) {
        var info = this.artData.split("@");
        this.newProject = info[0];
        this.thing = info[1];
        console.log("1-thing=" + this.thing);
      }
    }
    else {
      this.newProject = this.artData;
      this.thing = "";
      console.log("2-thing=" + this.thing);
    }
    this.re = /_/;
    if (this.newProject.match(this.re)) {
      var newArt = this.newProject.split("_");
      var newName = "";
      this.numberShapes = Number(newArt[0]);
      this.spreadsize = Number(newArt[1]);
      this.zoomsize = Number(newArt[2]);
      this.layers = Number(newArt[3]);
      this.rotateValue = Number(newArt[4]);
      this.scale = Number(newArt[5]);
      this.skewXValue = Number(newArt[6]);
      this.skewYValue = Number(newArt[7]);
      this.translateHValue = Number(newArt[8]);
      this.translateVValue = Number(newArt[9]);
      this.hue = Number(newArt[10]);
      this.sat = Number(newArt[11]);
      this.val = Number(newArt[12]);
      this.alpha = Number(newArt[13]);
      this.stroke = Number(newArt[14]);
      this.strokeWidth = Number(newArt[15]);
      this.backg = Number(newArt[16]);
      newName = String(newArt[17]);
      this.randomRotateValue = (newArt[18] + "").toLowerCase() === "true";
      this.randomScaleValue = (newArt[19] + "").toLowerCase() === "true";
      this.randomSkewXValue = (newArt[20] + "").toLowerCase() === "true";
      this.randomSkewYValue = (newArt[21] + "").toLowerCase() === "true";
      this.randomHValue = (newArt[22] + "").toLowerCase() === "true";
      this.randomVValue = (newArt[23] + "").toLowerCase() === "true";
      this.randomHueValue = (newArt[24] + "").toLowerCase() === "true";
      this.randomSatValue = (newArt[25] + "").toLowerCase() === "true";
      this.randomValValue = (newArt[26] + "").toLowerCase() === "true";
      this.randomAlphaValue = (newArt[27] + "").toLowerCase() === "true";
      this.randomStrokeColorValue = (newArt[28] + "").toLowerCase() === "true";
      this.randomStrokeWidthValue = (newArt[29] + "").toLowerCase() === "true";
    }
    else {
      newArt = this.newProject.split(" ");
      //alert("process1 - newArt - " + newArt);
      newName = "";
      console.log("200-thing" + this.thing);
      this.numberShapes = Number(newArt[0]);
      this.spreadsize = 200;
      this.zoomsize = 60;
      this.layers = Number(newArt[1]);
      this.rotateValue = Number(newArt[2]);
      this.scale = Number(newArt[3]);
      this.skewXValue = Number(newArt[4]);
      this.skewYValue = Number(newArt[5]);
      this.translateHValue = Number(newArt[6]);
      this.translateVValue = Number(newArt[7]);
      this.hue = Number(newArt[8]);
      this.sat = Number(newArt[9]);
      this.val = Number(newArt[10]);
      this.alpha = Number(newArt[11]);
      this.stroke = Number(newArt[12]);
      this.strokeWidth = Number(newArt[13]);
      this.backg = Number(newArt[14]);
      newName = String(newArt[15]);
      this.randomRotateValue = (newArt[16] + "").toLowerCase() === "true";
      this.randomScaleValue = (newArt[17] + "").toLowerCase() === "true";
      this.randomSkewXValue = (newArt[18] + "").toLowerCase() === "true";
      this.randomSkewYValue = (newArt[19] + "").toLowerCase() === "true";
      this.randomHValue = (newArt[20] + "").toLowerCase() === "true";
      this.randomVValue = (newArt[21] + "").toLowerCase() === "true";
      this.randomHueValue = false;
      this.randomSatValue = false;
      this.randomValValue = false;
      this.randomAlphaValue = false;
      this.randomStrokeColorValue = false;
      this.randomStrokeWidthValue = false;
    }
    this.outputTransform(
      "rotate",
      this.rotateValue,
      this.randomRotateValue,
      "scale",
      this.scale,
      this.randomScaleValue,
      "skewX",
      this.skewXValue,
      this.randomSkewXValue,
      "skewY",
      this.skewYValue,
      this.randomSkewYValue,
      "translate",
      this.translateHValue,
      this.randomHValue,
      this.translateVValue,
      this.randomVValue,
      this.numberShapes
    );
    this.strokeWithWhite2rgba(this.stroke);
    this.backgWithWhite2rgba(this.backg);
    this.hsv2rgba(this.hue, this.sat, this.val, this.alpha);
    ////////////////////////////////////////////////////////////////////////

    if (this.ignoreShape == false) {

      if (this.thing == "") {

        if (newName == "#kitchen") {
          this.shapeName = "#newShape";
          this.shapeID = this.setShape(this.shapeName);
          this.thing = document.getElementById(this.shapeID).innerHTML;
          console.log("5-thing=" + this.thing);
          this.shapeName = "#basement";
          this.shapeID = this.setShape(this.shapeName);
          document.getElementById(this.shapeID).innerHTML = this.thing;
          this.showData = this.thing;
          console.log("6-thing=" + this.thing);
          return;
        } //shapeName=#kitchen
        if (newName == "#basement") {
          this.shapeName = "#newShape";
          this.shapeID = this.setShape(this.shapeName);
          this.thing = document.getElementById(this.shapeID).innerHTML;
          console.log("5-thing=" + this.thing);
          this.shapeName = "#basement";
          this.shapeID = this.setShape(this.shapeName);
          document.getElementById(this.shapeID).innerHTML = this.thing;
          this.showData = this.thing;
          console.log("6-thing=" + this.thing);
          return;
        } //shapeName=#basement
        else {
          this.shapeName = newName;
          this.shapeID = this.setShape(this.shapeName);
          this.thing = document.getElementById(this.shapeID).innerHTML;
          console.log("7-thing=" + this.thing);
          this.shapeName = "#basement";
          this.shapeID = this.setShape(this.shapeName);
          document.getElementById(this.shapeID).innerHTML = this.thing;
          this.showData = this.thing;
          return;
        } //shapeName=newName
      }// no thing
      else if (this.thing !== "") {
        // this.shapeName = newName;
        // this.shapeID = this.setShape(this.shapeName);

        this.shapeName = "#basement";
        this.shapeID = this.setShape(this.shapeName);
        document.getElementById(this.shapeID).innerHTML = this.thing;
        this.showData = this.thing;
        console.log("8-thing=" + this.thing);
        return;
      }//thing exists
    }//ignorShape
    else if (this.ignoreShape == true) {
      newName = this.shapeName;
      this.shapeID = this.setShape(this.shapeName);
      this.thing = document.getElementById(this.shapeID).innerHTML;
      this.shapeName = "#basement";
      this.shapeID = this.setShape(this.shapeName);
      document.getElementById(this.shapeID).innerHTML = this.thing;
      console.log("4-thing=" + this.thing);
      this.showData = this.thing;
      return;
    }//ignorShape
  }

  private convertStageSize(stageSize) {
    stageSize = Number(stageSize);
    this.stageHalf = Number(stageSize / 2);
    this.svgx = ' x="' + this.stageHalf + ' px "';
    this.svgy = ' y="' + this.stageHalf + ' px "';
    this.svgwidtth = ' width="' + this.stageSize + ' px "';
    this.svgheight = ' height="' + this.stageSize + ' px "';
    this.svgviewbox = ' viewBox="' + this.stageHalf + ' ' + this.stageHalf + ' ' + stageSize + ' ' + stageSize + '"';
    this.svgstage = '<svg id="playspace" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"' +
      this.svgx +
      this.svgy +
      this.svgwidtth +
      this.svgheight +
      this.svgviewbox +
      ">";

    var line = document.getElementById("playspace");
    this.svgx = ' x="' + this.stageHalf + ' px "';

    this.svgy = ' y="' + this.stageHalf + ' px "';

    // line.setAttribute("x", String(this.stageHalf));

    //line.setAttribute("y", String(this.stageHalf));

    line.setAttribute("width", String(this.stageSize));

    line.setAttribute("height", String(this.stageSize));

    line.setAttribute(
      "viewbox",
      "" +
      this.stageHalf +
      " " +
      this.stageHalf +
      " " +
      stageSize +
      " " +
      stageSize +
      ""
    );

    return this.svgstage;
  }


  private randomFlow() {
    var count;
    for (count = 0; count < 100; count++) {
      this.mynum = Math.random();
      this.mynum = Math.floor(this.mynum);
    }
  }

  private fileChanged(e) {
    this.file = e.target.files[0];
  }

  private killColor() {
    var myobject;
    var plen;
    var i;
    var code;
    //var re = /<path\s+\w+\W+d=/gi;
    myobject = document.getElementById("basement").innerHTML;
    var parts = myobject.split(" ")
    plen = parts.length;
    for (i = 0; i < plen; i++) {
      if (parts[i].match("stroke")) { parts[i] = ""; }
      else if (parts[i].match("fill")) { parts[i] = ""; }

      code = code + " " + parts[i];
    }
    myobject = myobject + " " + code;
    document.getElementById("basement").innerHTML = myobject;

  }
  private useColor(paletteString) {
    var i = 0;

    this.colorString = paletteString.split(" ");
    this.plength = this.colorString.length;
    console.log(this.plength + "  this.colorString  " + this.colorString);
    for (i = 0; i < this.plength; i++) {
      var part = this.colorString[i].split(",");
      console.log("part   " + part);
      console.log("paletteString   " + paletteString);
      console.log(" this.colorString   " + this.colorString);

      var hue = Number(part[0]);
      var sat = Number(part[1]);
      var val = Number(part[2]);
      // var alpha = Number(part[3]);
      this.colors[i] = hue + "," + sat + "," + val + "," + this.alpha;
    }

  }

  private nextColor(hue, sat, val, alpha) {
    /*
        this.colorString = this.paletteString.split(" ");
        this.plength = this.colorString.length;
        */
    if (this.randomColor == true) {
      var rancount = this.getRandom(0, 360);
      this.colorNumber = rancount % this.plength;
    } else {
      this.colorNumber = this.counter % this.plength;
    }

    var part = this.colors[this.colorNumber].split(",");
    hue = Number(part[0]);
    sat = Number(part[1]);
    val = Number(part[2]);
    alpha = Number(part[3]);
    //console.log("hsva  " + hue + ", " + sat + ", " + val + ", " + alpha);

    this.rgbColor = this.hsv2rgba(hue, sat, val, alpha);
    return this.rgbColor;
  }

  private addColor(selectedColor) {
    //console.log("selectedColor", selectedColor);
    selectedColor.a = this.alpha;
    if (this.pastePaletteString) {
      this.paletteString = this.pastePaletteString;
    }
    else {
      if (this.paletteString === "") {
        this.paletteString +=
          selectedColor.h +
          "," +
          selectedColor.s +
          "," +
          selectedColor.b +
          "," +
          selectedColor.a;
      }
      else {
        this.paletteString =
          this.paletteString +
          " " +
          selectedColor.h +
          "," +
          selectedColor.s +
          "," +
          selectedColor.b +
          "," +
          selectedColor.a;
      }
    }
    //return this.paletteString;
    this.useColor(this.paletteString);
    if (this.usepalettebox == true) {
      selectedColor.a = this.alpha;
      this.rgbColor = this.nextColor(selectedColor.h, selectedColor.s, selectedColor.b, selectedColor.a);
      this.pastePaletteString = "";
      return this.rgbColor;
    }
  }

  private newPalette() {
    this.paletteString = "";
    this.useColor(this.paletteString);
  }

  private pastePalette() {
    this.pastePaletteString = prompt("Add a Palette");
    if (this.pastePaletteString == "") {
      this.pastePaletteString = '356,94,97,1 356,4,99,1 241,92,97,1';
    }
    this.useColor(this.pastePaletteString);
    return this.pastePaletteString;
  }
  private savePalette(filenameout) {
    //console.log("paletteString: " + this.paletteString);
    var dataout = this.yourname + "_palette.txt";
    this.mydownload([dataout], this.paletteString);
    this.useColor(this.paletteString);
  }



  private rotateit(irotate) {
    this.rememberDefaults();
    this.irotate = irotate;
    this.atype = "rotate";
    this.avalues = 0 + ';' + irotate + ';' + 0;
    var myset = irotate;
    this.iscaleX = 1;
    this.iscaleY = 1;
    this.iskewX = 0;
    this.iskewY = 0;
    this.imoveh = 0;
    this.imovev = 0;
    this.processprimitive(this.irotate, this.iscaleX, this.iscaleY, this.iskewX, this.iskewY, this.imoveh, this.imovev);
    this.recallDefaults();
    irotate = myset;
  }
  private rockit(irock) {
    this.rememberDefaults();
    this.irotate = irock;
    this.atype = "rotate";
    this.avalues = 0 + ';' + irock + ';' + 0;
    var myset = irock;
    this.iscaleX = 1;
    this.iscaleY = 1;
    this.iskewX = 0;
    this.iskewY = 0;
    this.imoveh = 0;
    this.imovev = 0;
    this.processprimitive(this.irotate, this.iscaleX, this.iscaleY, this.iskewX, this.iskewY, this.imoveh, this.imovev);
    this.recallDefaults();
    irock = myset;
  }
  private scaleitX(iscaleX) {
    this.rememberDefaults();
    this.iscaleX = iscaleX;
    this.atype = "scale";
    this.avalues = 1 + ' ' + 1 + ';' +
      iscaleX + ' ' + 1 + ';' +
      1 + ' ' + 1 + ';' +
      -iscaleX + ' ' + 1 + ';' +
      1 + ' ' + 1;
    var myset = iscaleX;
    this.irotate = 0;
    //this.iscaleX = .95;
    this.iscaleY = 1;
    this.iskewX = 0;
    this.iskewY = 0;
    this.imoveh = 0;
    this.imovev = 0;
    this.processprimitive(this.irotate, this.iscaleX, this.iscaleY, this.iskewX, this.iskewY, this.imoveh, this.imovev);
    this.recallDefaults();
    iscaleX = myset;
  }

  private scaleitY(iscaleY) {
    this.rememberDefaults();
    this.iscaleY = iscaleY;
    this.atype = "scale";
    this.avalues = 1 + ' ' + 1 + ';' +
      1 + ' ' + iscaleY + ';' +
      1 + ' ' + 1;
    var myset = iscaleY;
    this.irotate = 0;
    this.iscaleX = 1;
    //this.iscaleY = .9;
    this.iskewX = 0;
    this.iskewY = 0;
    this.imoveh = 0;
    this.imovev = 0;
    this.processprimitive(this.irotate, this.iscaleX, this.iscaleY, this.iskewX, this.iskewY, this.imoveh, this.imovev);
    this.recallDefaults();
    iscaleY = myset;
  }

  private scaleit(iscale) {
    this.rememberDefaults();
    this.iscale = iscale;
    this.atype = "scale";
    this.avalues = .1 + ';' + iscale + ';' + .1;
    var myset = iscale;
    this.irotate = 0;
    this.iscaleX = iscale;
    this.iscaleY = iscale;
    this.iskewX = 0;
    this.iskewY = 0;
    this.imoveh = 0;
    this.imovev = 0;
    this.processprimitive(this.irotate, this.iscaleX, this.iscaleY, this.iskewX, this.iskewY, this.imoveh, this.imovev);
    this.recallDefaults();
    iscale = myset;
  }

  private skewitX(iskewX) {
    this.rememberDefaults();
    this.iskewX = iskewX;
    this.atype = "skewX";
    this.avalues = 0 + ';' +
      iskewX + ';' +
      0 + ';' +
      -iskewX + ';' +
      0;
    var myset = iskewX;
    this.irotate = 0;
    this.iscaleX = 1;
    this.iscaleY = 1;
    //this.iskewX = 20;
    this.iskewY = 0;
    this.imoveh = 0;
    this.imovev = 0;
    this.processprimitive(this.irotate, this.iscaleX, this.iscaleY, this.iskewX, this.iskewY, this.imoveh, this.imovev);
    this.recallDefaults();
    iskewX = myset;
  }

  private skewitY(iskewY) {
    this.rememberDefaults();
    this.iskewY = iskewY;
    this.atype = "skewY";
    this.avalues = 0 + ';' +
      iskewY + ';' +
      0 + ';' +
      -iskewY + ';' +
      0;
    var myset = iskewY;
    this.irotate = 0;
    this.iscaleX = 1;
    this.iscaleY = 1;
    this.iskewX = 0;
    //this.iskewY = -30;
    this.imoveh = 0;
    this.imovev = 0;
    this.processprimitive(this.irotate, this.iscaleX, this.iscaleY, this.iskewX, this.iskewY, this.imoveh, this.imovev);
    this.recallDefaults();
    iskewY = myset;
  }

  private moveith(imoveh) {
    this.rememberDefaults();
    this.imoveh = this.scale * imoveh;
    this.atype = "translate";
    this.avalues = 0 + ' ' + 0 + ';' +
      imoveh + ' ' + 0 + ';' +
      0 + ' ' + 0 + ';' +
      -imoveh + ' ' + 0 + ';' +
      0 + ' ' + 0;
    var myset = imoveh;
    this.irotate = 0;
    this.iscaleX = 1;
    this.iscaleY = 1;
    this.iskewX = 0;
    this.iskewY = 0;
    //this.imoveh = 80;
    this.imovev = 0;
    this.processprimitive(this.irotate, this.iscaleX, this.iscaleY, this.iskewX, this.iskewY, this.imoveh, this.imovev);
    this.recallDefaults(); this.recallDefaults();
    imoveh = myset;
  }

  private moveitv(imovev) {
    this.rememberDefaults();
    this.imovev = this.scale * imovev;
    this.atype = "translate";
    this.avalues =
      0 + ' ' + 0 + ';' +
      0 + ' ' + imovev + ';' +
      0 + ' ' + 0 + ';' +
      0 + ' ' + -imovev + ';' +
      0 + ' ' + 0;
    var myset = imovev;
    this.irotate = 0;
    this.iscaleX = 1;
    this.iscaleY = 1;
    this.iskewX = 0;
    this.iskewY = 0;
    this.imoveh = 0;
    //this.imovev = 80
    this.processprimitive(this.irotate, this.iscaleX, this.iscaleY, this.iskewX, this.iskewY, this.imoveh, this.imovev);
    this.recallDefaults();
    imovev = myset;
  }

  private flipleft(imoveh) {
    this.rememberDefaults();
    this.imoveh = this.scale * imoveh;
    var myset = imoveh;
    this.irotate = 0;
    this.iscaleX = -1;
    this.iscaleY = 1;
    this.iskewX = 0;
    this.iskewY = 0;
    // this.imoveh = 100;
    this.imovev = 0;
    this.processprimitive(this.irotate, this.iscaleX, this.iscaleY, this.iskewX, this.iskewY, this.imoveh, this.imovev);
    this.recallDefaults();
    imoveh = myset;
  }

  private flipup(imovev) {
    this.rememberDefaults();
    this.imovev = this.scale * imovev;
    var myset = imovev;
    this.irotate = 0;
    this.iscaleX = 1;
    this.iscaleY = -1;
    this.iskewX = 0;
    this.iskewY = 0;
    this.imoveh = 0;
    //this.imovev = this.imovev;
    this.processprimitive(this.irotate, this.iscaleX, this.iscaleY, this.iskewX, this.iskewY, this.imoveh, this.imovev);
    this.recallDefaults();
    imovev = myset;
  }
  private rememberDefaults() {
    this.modifyit = [
      this.irotate,
      this.iscaleX,
      this.iscaleY,
      this.iscale,
      this.iskewX,
      this.iskewY,
      this.imoveh,
      this.imovev,
      this.default];
    return this.modifyit;
  }
  private recallDefaults() {
    this.irotate = this.modifyit[0];
    this.iscaleX = this.modifyit[1];
    this.iscaleY = this.modifyit[2];
    this.iscale = this.modifyit[3];
    this.iskewX = this.modifyit[4];
    this.iskewY = this.modifyit[5];
    this.imoveh = this.modifyit[6];
    this.imovev = this.modifyit[7];
    this.default = this.modifyit[8];
  }
  private clearall() {
    this.default = 6;
  }
  private defaults() {

    if (this.default == 1) {
      this.irotate = 45;
      this.iscaleX = .8;
      this.iscaleY = .8;
      this.iscale = 3;
      this.iskewX = 30;
      this.iskewY = 30;
      this.imoveh = 100;
      this.imovev = 100;
      this.default = 2;
    }
    else if (this.default == 2) {
      this.irotate = -10;
      this.iscaleX = -1;
      this.iscaleY = -1;
      this.iscale = -.8;
      this.iskewX = -20;
      this.iskewY = -20;
      this.imoveh = -20;
      this.imovev = -20;
      this.default = 3;
    }
    else if (this.default == 3) {
      this.irotate = 360;
      this.iscaleX = 4;
      this.iscaleY = 4;
      this.iscale = 5;
      this.iskewX = 80;
      this.iskewY = 80;
      this.imoveh = 700;
      this.imovev = 700;
      this.default = 4;
    }
    else if (this.default == 4) {
      this.irotate = 10;
      this.iscaleX = .9;
      this.iscaleY = .9;
      this.iscale = .8;
      this.iskewX = 20;
      this.iskewY = 20;
      this.imoveh = 20;
      this.imovev = 20;
      this.default = 5;
    }
    else if (this.default == 5) {
      this.irotate = 60;
      this.iscaleX = 1.5;
      this.iscaleY = 1.5;
      this.iscale = .7;
      this.iskewX = 30;
      this.iskewY = 30;
      this.imoveh = 20;
      this.imovev = 20;
      this.default = 6;
    }
    else if (this.default == 6) {
      this.irotate = 0;
      this.iscaleX = 1;
      this.iscaleY = 1;
      this.iscale = 1;
      this.iskewX = 0;
      this.iskewY = 0;
      this.imoveh = 0;
      this.imovev = 0;
      this.default = 7;
    }
    else if (this.default == 7) {
      this.irotate = -60;
      this.iscaleX = -1.5;
      this.iscaleY = -1.5;
      this.iscale = -3;
      this.iskewX = -10;
      this.iskewY = -10;
      this.imoveh = -200;
      this.imovev = -200;
      this.default = 1;

    }
  }
  private doall() {
    this.moveith(this.imoveh);
    this.moveitv(this.imovev);
    this.rotateit(this.irotate);
    this.scaleit(this.iscale);
    this.skewitX(this.iskewX);
    this.skewitY(this.iskewY);
  }

  private processprimitive(irotate, iscaleX, iscaleY, iskewX, iskewY, imoveh, imovev) {
    this.shapeID = this.setShape(this.shapeName);
    var myshape = document.getElementById(this.shapeID);
    var mymirror = myshape.innerHTML;
    var action = '<g transform ="' +
      "rotate(" + irotate + "," + 0 + "," + 0 + ") " +
      "scale(" + iscaleX + "," + iscaleY + ") " +
      "skewX(" + iskewX + ") " +
      "skewY(" + iskewY + ") " +
      "translate(" +
      imoveh +
      "," +
      imovev +
      ')">';
    action = action + mymirror + '</g>';
    mymirror = mymirror + action;
    if (this.duplicateShape == true) {
      document.getElementById(this.shapeID).innerHTML = mymirror;
    }
    else if (this.moveShape == true) {
      document.getElementById(this.shapeID).innerHTML = action;
    }
    this.default = 1;
    this.defaults();
  }

  private buildbasement() {
    this.shapeID = this.setShape(this.shapeName);
    this.newbase = document.getElementById(this.shapeID).innerHTML;
    this.basement = document.getElementById("basement").innerHTML;
    this.basement = this.newbase + this.basement;
    document.getElementById("basement").innerHTML = this.basement
    this.setShape('#basement');
    this.showData = this.basement;

  }


  private buildaddit() {
    this.shapeID = this.setShape(this.shapeName);
    this.newbase = document.getElementById(this.shapeID).innerHTML;
    this.basement = document.getElementById("doit").innerHTML;
    this.basement = this.newbase + this.basement;
    document.getElementById(this.shapeID).innerHTML = this.basement
    this.setShape(this.shapeName);

  }

  private buildkitchen() {
    this.shapeID = this.setShape(this.shapeName);
    this.newbase = document.getElementById(this.shapeID).innerHTML;
    this.kitchen = document.getElementById("kitchen").innerHTML;
    this.kitchen = this.newbase + this.kitchen;
    document.getElementById("kitchen").innerHTML = this.kitchen
    this.setShape('#kitchen');
  }


  private buildbasemoveh() {
    this.shapeID = this.setShape(this.shapeName);
    this.newbase = document.getElementById(this.shapeID).innerHTML;
    this.basemoveh = document.getElementById("basemoveh").innerHTML;
    this.outbase = "<g>" + this.basemoveh + ' ' + this.newbase + '</g>';
    document.getElementById("basemoveh").innerHTML = this.outbase;
    this.setShape('#basemoveh');
  }

  private buildbasemovev() {
    this.shapeID = this.setShape(this.shapeName);
    this.newbase = document.getElementById(this.shapeID).innerHTML;
    this.basemovev = document.getElementById("basemovev").innerHTML;
    this.outbase = "<g>" + this.basemovev + ' ' + this.newbase + '</g>';
    document.getElementById("basemovev").innerHTML = this.outbase;
    this.setShape('#basemovev');
  }

  private buildbaserotate() {
    this.shapeID = this.setShape(this.shapeName);
    this.newbase = document.getElementById(this.shapeID).innerHTML;
    this.baserotate = document.getElementById("baserotate").innerHTML;
    this.outbase = "<g>" + this.baserotate + ' ' + this.newbase + '</g>';
    document.getElementById("baserotate").innerHTML = this.outbase;
    this.setShape('#baserotate');
  }

  private buildbasescale() {
    this.shapeID = this.setShape(this.shapeName);
    this.newbase = document.getElementById(this.shapeID).innerHTML;
    this.basescale = document.getElementById("basescale").innerHTML;
    this.outbase = "<g>" + this.basescale + ' ' + this.newbase + '</g>';
    document.getElementById("basescale").innerHTML = this.outbase;
    this.setShape('#basescale');
  }

  private buildbasescalex() {
    this.shapeID = this.setShape(this.shapeName);
    this.newbase = document.getElementById(this.shapeID).innerHTML;
    this.basescaleX = document.getElementById("basescaleX").innerHTML;
    this.outbase = "<g>" + this.basescaleX + ' ' + this.newbase + '</g>';
    document.getElementById("basescaleX").innerHTML = this.outbase;
    this.setShape('#basescaleX');
  }

  private buildbasescaley() {
    this.shapeID = this.setShape(this.shapeName);
    this.newbase = document.getElementById(this.shapeID).innerHTML;
    this.basescaleY = document.getElementById("basescaleY").innerHTML;
    this.outbase = "<g>" + this.basescaleY + ' ' + this.newbase + '</g>';
    document.getElementById("basescaleY").innerHTML = this.outbase;
    this.setShape('#basescaleY');
  }

  private buildbaseskewx() {
    this.shapeID = this.setShape(this.shapeName);
    this.newbase = document.getElementById(this.shapeID).innerHTML;
    this.baseskewX = document.getElementById("baseskewX").innerHTML;
    this.outbase = "<g>" + this.baseskewX + ' ' + this.newbase + '</g>';
    document.getElementById("baseskewX").innerHTML = this.outbase;
    this.setShape('#baseskewX');
  }

  private buildbaseskewy() {
    this.shapeID = this.setShape(this.shapeName);
    this.newbase = document.getElementById(this.shapeID).innerHTML;
    this.baseskewY = document.getElementById("baseskewY").innerHTML;
    this.outbase = "<g>" + this.baseskewY + ' ' + this.newbase + '</g>';
    console.log("outbase" + this.outbase);
    document.getElementById("baseskewY").innerHTML = this.outbase;
    this.setShape('#baseskewY');
  }

  private clearbasement() {
    this.shapeName = "basement";
    this.shapeID = this.setShape(this.shapeName);
    document.getElementById(this.shapeName).innerHTML = "";
    this.shapeID = this.setShape(this.shapeName);
    this.shapeData = "";
    this.showData = this.shapeData;
  }

  private clearkitchen() {
    this.shapeName = "kitchen";
    this.shapeID = this.setShape(this.shapeName);
    document.getElementById(this.shapeName).innerHTML = "";
    this.shapeID = this.setShape(this.shapeName);
  }

  private BW() {
    if (this.backg == 0) { this.backg = 360; }
    if (this.backg == 360) { this.backg = 0; }
    return this.backg;
  }
  private oneShape() {

    if (this.shapeName == "#kitchen" || this.shapeName == "#polyShape") {
      this.buildbasement();
    }
    this.rememberArtData =
      this.numberShapes +
      "_" +
      this.spreadsize +
      "_" +
      this.zoomsize +
      "_" +
      this.layers +
      "_" +
      this.rotateValue +
      "_" +
      this.scale +
      "_" +
      this.skewXValue +
      "_" +
      this.skewYValue +
      "_" +
      this.translateHValue +
      "_" +
      this.translateVValue +
      "_" +
      this.hue +
      "_" +
      this.sat +
      "_" +
      this.val +
      "_" +
      this.alpha +
      "_" +
      this.stroke +
      "_" +
      this.strokeWidth +
      "_" +
      this.backg +
      "_" +
      this.shapeName +
      "_" +
      this.randomRotateValue +
      "_" +
      this.randomScaleValue +
      "_" +
      this.randomSkewXValue +
      "_" +
      this.randomSkewYValue +
      "_" +
      this.randomHValue +
      "_" +
      this.randomVValue +
      "_" +
      this.randomHueValue +
      "_" +
      this.randomSatValue +
      "_" +
      this.randomValValue +
      "_" +
      this.randomAlphaValue +
      "_" +
      this.randomStrokeColorValue +
      "_" +
      this.randomStrokeWidthValue;

    if (this.shapeName == "#basement ") {
      this.shapeID = this.setShape(this.shapeName);
      this.shapeData = document.getElementById(this.shapeID).innerHTML;
      this.showData = this.shapeData;
      this.rememberArtData = this.rememberArtData + "@" + this.shapeData;
      document.getElementById("rememberartdata").innerHTML = this.rememberArtData;
    }
    document.getElementById("rememberartdata").innerHTML = this.rememberArtData;
    //Set art data to one
    this.newProject = '1_0_60_1_5_2_0_0_0_0_10_100_100_1_0_5_360_' + this.shapeName + '_false_false_false_false_false_false_false_false_false_false_false_false';
    //console.log(" 3a- rememberArtData: " + this.rememberArtData);
    //console.log("3b- newProject: " + this.newProject);
    this.processArtData(this.newProject);
  }

  private recover() {
    this.artData = document.getElementById("rememberartdata").innerHTML;
    document.getElementById("rememberartdata").innerHTML = " ";
    this.processArtData(this.artData);
  }
  private scrollPalette() {
    if (this.usepalettebox == true) {
      this.usepalettebox = false;
      document.getElementById("palette").scrollIntoView({ behavior: 'auto' });
    }
    else if (this.usepalettebox == false) {
      this.usepalettebox = true;
      document.getElementById("palette").scrollIntoView({ behavior: 'auto' });
    }
  }

  private scrollpresets() { document.getElementById("presets").scrollIntoView({ behavior: 'auto' }); }
  private scrollart() { document.getElementById("art").scrollIntoView({ behavior: 'auto' }); }
  private scrollbox() { document.getElementById("box").scrollIntoView({ behavior: 'auto' }); }
  private scrollpaletteplacement() { document.getElementById("paletteplacement").scrollIntoView({ behavior: 'auto' }); }
  private scrollplacement() { document.getElementById("placement").scrollIntoView({ behavior: 'auto' }); }
  private scrollrememberartdata() { document.getElementById("rememberartdata").scrollIntoView({ behavior: 'auto' }); }
  private scrolltransformation() { document.getElementById("transformation").scrollIntoView({ behavior: 'auto' }); }
  private scrollprimitives() { document.getElementById("primitives").scrollIntoView({ behavior: 'auto' }); }
  private scrollcontainers() { document.getElementById("containers").scrollIntoView({ behavior: 'auto' }); }
  private scrolltools() { document.getElementById("tools").scrollIntoView({ behavior: 'auto' }); }
  private scrollArtObjects() { document.getElementById("ArtObjects").scrollIntoView({ behavior: 'auto' }); }
  private scrolldatacontrol() { document.getElementById("datacontrol").scrollIntoView({ behavior: 'auto' }); }
  private scrollobjectcontrol() { document.getElementById("objectcontrol").scrollIntoView({ behavior: 'auto' }); }
  private scrollartcontrol() { document.getElementById("artcontrol").scrollIntoView({ behavior: 'auto' }); }
  private scrolltoolbox() { document.getElementById("toolbox").scrollIntoView({ behavior: 'auto' }); }
  private scrollspecialsliders() { document.getElementById("specialsliders").scrollIntoView({ behavior: 'auto' }); }
  private scrollshapesliders() { document.getElementById("shapesliders").scrollIntoView({ behavior: 'auto' }); }
  private scrollcolorsliders() { document.getElementById("colorsliders").scrollIntoView({ behavior: 'auto' }); }
  private scrollmoresliders() { document.getElementById("moresliders").scrollIntoView({ behavior: 'auto' }); }
  private scrolltop() { document.getElementById("top").scrollIntoView({ behavior: 'auto' }); }

  private artDataDemo(newDemo) {
    var name;
    if (newDemo == "birdsfeetDemo") {

      this.newProject = "1_200_60_2_0_1_0_0_ -200_183_113_100_100_1_365_5_0_#kitchen _false_false_false_false_false_false_false_false_false_false_false_false";
      this.thing = '<g><g><polygon  points="206.323,570.564 421.252,259.573 255.097,398.838 288.379,403.242 146.364,573.303 273.729,452.972 "/><polygon  points="258.204,603.367 361.429,202.403 253.675,410.341 284.185,401.271 206.188,630.473 285.033,457.382 "/></g><g><polygon fill="#40AFCE" points="366.662,421.977 104.676,482.109 343.157,326.508 283.908,392.52 469.607,314.571 291.628,419.194 "/><polygon points="339.196,438.413 100.11,420.35 363.922,351.862 285.857,391.91 471.498,374.968 279.88,416.396 "/><polygon points="316.82,460.423 132.576,317.93 360.932,402.747 287.753,393.85 439.586,479.128 276.079,410.71 "/><polygon points="292.678,466.197 188.362,247.903 343.676,443.218 288.721,395.614 383.801,549.155 274.772,403.004 "/><polygon fill="#7AC143" points="274.893,446.82 230.458,236.854 330.322,465.159 289.398,398.356 341.705,560.205 273.951,394.059 "/><polygon points="264.39,423.334 277.161,243.377 308.658,477.564 289.138,400.297 295.189,552.502 276.6,385.751 "/></g></g>';
    }
    else if (newDemo == "circleDemo") {

      this.newProject = "1_0_1_1_5_5_0_0_0_0_10_100_100_1_0_5_360_#circle_false_false_false_false_false_false_false_false_false_false_false_false";
      this.thing = '<circle  cx="0" cy="0" r="20"/>';
    }
    else if (newDemo == "ellipseDemo") {

      this.newProject = "1_200_360_360_0_5_0_0_-200_200_10_100_100_1_0_0_360_#ellipse_false_false_false_false_false_false_false_false_false_false_false_false";
      this.thing = "";
    }
    else if (newDemo == "fileShapeDemo") {

      this.newProject = "4_200_60_360_0_0.22_0_0_-7_-36_10_100_100_1_0_1_0_#fileShape_false_false_false_false_false_false_false_false_false_false_true_false";
      this.thing = "";
    }
    else if (newDemo == "demoDemo") {

      this.newProject = "1_200_60_2_0_1_0_0_-200_183_113_100_100_1_365_5_0_#kitchen _false_false_false_false_false_false_false_false_false_false_false_false";
      this.thing = '<g>'
        + '<g>'
        + '<polygon fill="#F5DC37" stroke="#000000" stroke-miterlimit="10" points="206.323,570.564 421.252,259.573 255.097,398.838 288.379, 403.242 146.364, 573.303 273.729, 452.972 "/>'
        + '<polygon fill="#3EA1DA" stroke="#000000" stroke-miterlimit="10"  points="258.204,603.367 361.429,202.403 253.675,410.341 284.185,401.271 206.188,630.473 285.033,457.382 "/>'
        + '</g>'
        + '<g>'
        + '<polygon fill="#40AFCE"  stroke-miterlimit="10" points="366.662,421.977 104.676,482.109 343.157,326.508 283.908,392.52 469.607,314.571 291.628,419.194 "/>'
        + '<polygon stroke="#000000" stroke-miterlimit="10" points="339.196,438.413 100.11,420.35 363.922,351.862 285.857,391.91 471.498,374.968 279.88,416.396 "/>'
        + '<polygon fill="#D81869"  stroke-miterlimit="10" points="316.82,460.423 132.576,317.93 360.932,402.747 287.753,393.85 439.586,479.128 276.079,410.71 "/>'
        + '<polygon stroke="#000000" stroke-miterlimit="10" points="292.678,466.197 188.362,247.903 343.676,443.218 288.721,395.614 383.801,549.155 274.772,403.004 "/>'
        + '<polygon fill="#7AC143"  stroke-miterlimit="10" points="274.893,446.82 230.458,236.854 330.322,465.159 289.398,398.356 341.705,560.205 273.951,394.059 "/>'
        + '<polygon  stroke="#000000" stroke-miterlimit="10" points="264.39,423.334 277.161,243.377 308.658,477.564 289.138,400.297 295.189,552.502 276.6,385.751 "/>'
        + '</g>'
        + '</g>';
    }
    else if (newDemo == "fullDemo") {

      this.newProject = "6_200_1_184_0_0.01_0_0_0_0_8_100_100_1_221_1_360_#hexagon_false_false_false_false_false_false_false_false_false_false_false_false";
      this.thing = "";
    }
    else if (newDemo == "fillDemo") {

      this.newProject = "3_200_60_360_0_0.5_0_0_9_ -23_10_100_100_1_365_0_0_#circle_false_false_false_false_false_false_false_false_false_false_false_false";
      this.thing = "";
    }
    else if (newDemo == "flowerDemo") {

      this.newProject = "1 12 0 1 0 0 -199 200 10 100 100 0 365 5 0 #kitchen  false false false false false false";
      this.thing = '<g><circle  cx="-1.707" cy="-0.777" r="353.906"/>'
        + '<circle  cx="-2.947" cy="352.344" r="353.906"/>'
        + '<circle  cx="304.865" cy="177.344" r="353.906"/>'
        + '<circle  cx="310.938" cy="-175.781" r="353.906"/>'
        + '<circle  cx="4.688" cy="-352.344" r="353.906"/>'
        + '<circle  cx="-306.25" cy="-183.594" r="353.906"/>'
        + '<circle  cx="-310.938" cy="175.781" r="353.906"/>'
        + '</g>';
    }
    else if (newDemo == "gridDemo") {

      this.newProject = "1_200_60_1_0_6_0_-2_-201_199_10_100_100_1_0_1_360_#kitchen_false_false_false_false_false_false_false_false_false_false_false_false";
      this.thing = '<g>'
        + '<g>'
        + '<rect x="-144" y="-144"  width="72" height="72"/>'
        + '<rect x="-144" y="-144"  width="18" height="18"/>'
        + '<rect x="-144" y="-126"  width="18" height="18"/>'
        + '<rect x="-144" y="-108"  width="18" height="18"/>'
        + '<rect x="-144" y="-90"  width="18" height="18"/>'
        + '<rect x="-126" y="-144"  width="18" height="18"/>'
        + '<rect x="-126" y="-126"  width="18" height="18"/>'
        + '<rect x="-126" y="-108"  width="18" height="18"/>'
        + '<rect x="-126" y="-90"  width="18" height="18"/>'
        + '<rect x="-108" y="-144"  width="18" height="18"/>'
        + '<rect x="-108" y="-126"  width="18" height="18"/>'
        + '<rect x="-108" y="-108"  width="18" height="18"/>'
        + '<rect x="-108" y="-90"  width="18" height="18"/>'
        + '<rect x="-90" y="-144"  width="18" height="18"/>'
        + '<rect x="-90" y="-126"  width="18" height="18"/>'
        + '<rect x="-90" y="-108"  width="18" height="18"/>'
        + '<rect x="-90" y="-90"  width="18" height="18"/>'
        + '</g>'
        + '<g>'
        + '<rect x="-72" y="-144"  width="72" height="72"/>'
        + '<rect x="-72" y="-144"  width="18" height="18"/>'
        + '<rect x="-72" y="-126"  width="18" height="18"/>'
        + '<rect x="-72" y="-108"  width="18" height="18"/>'
        + '<rect x="-72" y="-90"  width="18" height="18"/>'
        + '<rect x="-54" y="-144"  width="18" height="18"/>'
        + '<rect x="-54" y="-126"  width="18" height="18"/>'
        + '<rect x="-54" y="-108"  width="18" height="18"/>'
        + '<rect x="-54" y="-90"  width="18" height="18"/>'
        + '<rect x="-36" y="-144"  width="18" height="18"/>'
        + '<rect x="-36" y="-126"  width="18" height="18"/>'
        + '<rect x="-36" y="-108"  width="18" height="18"/>'
        + '<rect x="-36" y="-90"  width="18" height="18"/>'
        + '<rect x="-18" y="-144"  width="18" height="18"/>'
        + '<rect x="-18" y="-126"  width="18" height="18"/>'
        + '<rect x="-18" y="-108"  width="18" height="18"/>'
        + '<rect x="-18" y="-90"  width="18" height="18"/>'
        + '</g>'
        + '<g>'
        + '<rect x="0" y="-144"  width="72" height="72"/>'
        + '<rect y="-144"  width="18" height="18"/>'
        + '<rect y="-126"  width="18" height="18"/>'
        + '<rect y="-108"  width="18" height="18"/>'
        + '<rect y="-90"  width="18" height="18"/>'
        + '<rect x="18" y="-144"  width="18" height="18"/>'
        + '<rect x="18" y="-126"  width="18" height="18"/>'
        + '<rect x="18" y="-108"  width="18" height="18"/>'
        + '<rect x="18" y="-90"  width="18" height="18"/>'
        + '<rect x="36" y="-144"  width="18" height="18"/>'
        + '<rect x="36" y="-126"  width="18" height="18"/>'
        + '<rect x="36" y="-108"  width="18" height="18"/>'
        + '<rect x="36" y="-90"  width="18" height="18"/>'
        + '<rect x="54" y="-144"  width="18" height="18"/>'
        + '<rect x="54" y="-126"  width="18" height="18"/>'
        + '<rect x="54" y="-108"  width="18" height="18"/>'
        + '<rect x="54" y="-90"  width="18" height="18"/>'
        + '</g>'
        + '<g>'
        + '<rect x="72" y="-144"  width="72" height="72"/>'
        + '<rect x="72" y="-144"  width="18" height="18"/>'
        + '<rect x="72" y="-126"  width="18" height="18"/>'
        + '<rect x="72" y="-108"  width="18" height="18"/>'
        + '<rect x="72" y="-90"  width="18" height="18"/>'
        + '<rect x="90" y="-144"  width="18" height="18"/>'
        + '<rect x="90" y="-126"  width="18" height="18"/>'
        + '<rect x="90" y="-108"  width="18" height="18"/>'
        + '<rect x="90" y="-90"  width="18" height="18"/>'
        + '<rect x="108" y="-144"  width="18" height="18"/>'
        + '<rect x="108" y="-126"  width="18" height="18"/>'
        + '<rect x="108" y="-108"  width="18" height="18"/>'
        + '<rect x="108" y="-90"  width="18" height="18"/>'
        + '<rect x="126" y="-144"  width="18" height="18"/>'
        + '<rect x="126" y="-126"  width="18" height="18"/>'
        + '<rect x="126" y="-108"  width="18" height="18"/>'
        + '<rect x="126" y="-90"  width="18" height="18"/>'
        + '</g>'
        + '<g>'
        + '<rect x="-144" y="-72"  width="72" height="72"/>'
        + '<rect x="-144" y="-72"  width="18" height="18"/>'
        + '<rect x="-144" y="-54"  width="18" height="18"/>'
        + '<rect x="-144" y="-36"  width="18" height="18"/>'
        + '<rect x="-144" y="-18"  width="18" height="18"/>'
        + '<rect x="-126" y="-72"  width="18" height="18"/>'
        + '<rect x="-126" y="-54"  width="18" height="18"/>'
        + '<rect x="-126" y="-36"  width="18" height="18"/>'
        + '<rect x="-126" y="-18"  width="18" height="18"/>'
        + '<rect x="-108" y="-72"  width="18" height="18"/>'
        + '<rect x="-108" y="-54"  width="18" height="18"/>'
        + '<rect x="-108" y="-36"  width="18" height="18"/>'
        + '<rect x="-108" y="-18"  width="18" height="18"/>'
        + '<rect x="-90" y="-72"  width="18" height="18"/>'
        + '<rect x="-90" y="-54"  width="18" height="18"/>'
        + '<rect x="-90" y="-36"  width="18" height="18"/>'
        + '<rect x="-90" y="-18"  width="18" height="18"/>'
        + '</g>'
        + '<g>'
        + '<rect x="-72" y="-72"  width="72" height="72"/>'
        + '<rect x="-72" y="-72"  width="18" height="18"/>'
        + '<rect x="-72" y="-54"  width="18" height="18"/>'
        + '<rect x="-72" y="-36"  width="18" height="18"/>'
        + '<rect x="-72" y="-18"  width="18" height="18"/>'
        + '<rect x="-54" y="-72"  width="18" height="18"/>'
        + '<rect x="-54" y="-54"  width="18" height="18"/>'
        + '<rect x="-54" y="-36"  width="18" height="18"/>'
        + '<rect x="-54" y="-18"  width="18" height="18"/>'
        + '<rect x="-36" y="-72"  width="18" height="18"/>'
        + '<rect x="-36" y="-54"  width="18" height="18"/>'
        + '<rect x="-36" y="-36"  width="18" height="18"/>'
        + '<rect x="-36" y="-18"  width="18" height="18"/>'
        + '<rect x="-18" y="-72"  width="18" height="18"/>'
        + '<rect x="-18" y="-54"  width="18" height="18"/>'
        + '<rect x="-18" y="-36"  width="18" height="18"/>'
        + '<rect x="-18" y="-18"  width="18" height="18"/>'
        + '</g>'
        + '<g>'
        + '<rect x="0" y="-72"  width="72" height="72"/>'
        + '<rect y="-72"  width="18" height="18"/>'
        + '<rect y="-54"  width="18" height="18"/>'
        + '<rect y="-36"  width="18" height="18"/>'
        + '<rect y="-18"  width="18" height="18"/>'
        + '<rect x="18" y="-72"  width="18" height="18"/>'
        + '<rect x="18" y="-54"  width="18" height="18"/>'
        + '<rect x="18" y="-36"  width="18" height="18"/>'
        + '<rect x="18" y="-18"  width="18" height="18"/>'
        + '<rect x="36" y="-72"  width="18" height="18"/>'
        + '<rect x="36" y="-54"  width="18" height="18"/>'
        + '<rect x="36" y="-36"  width="18" height="18"/>'
        + '<rect x="36" y="-18"  width="18" height="18"/>'
        + '<rect x="54" y="-72"  width="18" height="18"/>'
        + '<rect x="54" y="-54"  width="18" height="18"/>'
        + '<rect x="54" y="-36"  width="18" height="18"/>'
        + '<rect x="54" y="-18"  width="18" height="18"/>'
        + '</g>'
        + '<g>'
        + '<rect x="72" y="-72"  width="72" height="72"/>'
        + '<rect x="72" y="-72"  width="18" height="18"/>'
        + '<rect x="72" y="-54"  width="18" height="18"/>'
        + '<rect x="72" y="-36"  width="18" height="18"/>'
        + '<rect x="72" y="-18"  width="18" height="18"/>'
        + '<rect x="90" y="-72"  width="18" height="18"/>'
        + '<rect x="90" y="-54"  width="18" height="18"/>'
        + '<rect x="90" y="-36"  width="18" height="18"/>'
        + '<rect x="90" y="-18"  width="18" height="18"/>'
        + '<rect x="108" y="-72"  width="18" height="18"/>'
        + '<rect x="108" y="-54"  width="18" height="18"/>'
        + '<rect x="108" y="-36"  width="18" height="18"/>'
        + '<rect x="108" y="-18"  width="18" height="18"/>'
        + '<rect x="126" y="-72"  width="18" height="18"/>'
        + '<rect x="126" y="-54"  width="18" height="18"/>'
        + '<rect x="126" y="-36"  width="18" height="18"/>'
        + '<rect x="126" y="-18"  width="18" height="18"/>'
        + '</g>'
        + '<g>'
        + '<rect x="-144" y="0"  width="72" height="72"/>'
        + '<rect x="-144"  width="18" height="18"/>'
        + '<rect x="-144" y="18"  width="18" height="18"/>'
        + '<rect x="-144" y="36"  width="18" height="18"/>'
        + '<rect x="-144" y="54"  width="18" height="18"/>'
        + '<rect x="-126"  width="18" height="18"/>'
        + '<rect x="-126" y="18"  width="18" height="18"/>'
        + '<rect x="-126" y="36"  width="18" height="18"/>'
        + '<rect x="-126" y="54"  width="18" height="18"/>'
        + '<rect x="-108"  width="18" height="18"/>'
        + '<rect x="-108" y="18"  width="18" height="18"/>'
        + '<rect x="-108" y="36"  width="18" height="18"/>'
        + '<rect x="-108" y="54"  width="18" height="18"/>'
        + '<rect x="-90"  width="18" height="18"/>'
        + '<rect x="-90" y="18"  width="18" height="18"/>'
        + '<rect x="-90" y="36"  width="18" height="18"/>'
        + '<rect x="-90" y="54"  width="18" height="18"/>'
        + '</g>'
        + '<g>'
        + '<rect x="-72" y="0"  width="72" height="72"/>'
        + '<rect x="-72"  width="18" height="18"/>'
        + '<rect x="-72" y="18"  width="18" height="18"/>'
        + '<rect x="-72" y="36"  width="18" height="18"/>'
        + '<rect x="-72" y="54"  width="18" height="18"/>'
        + '<rect x="-54"  width="18" height="18"/>'
        + '<rect x="-54" y="18"  width="18" height="18"/>'
        + '<rect x="-54" y="36"  width="18" height="18"/>'
        + '<rect x="-54" y="54"  width="18" height="18"/>'
        + '<rect x="-36"  width="18" height="18"/>'
        + '<rect x="-36" y="18"  width="18" height="18"/>'
        + '<rect x="-36" y="36"  width="18" height="18"/>'
        + '<rect x="-36" y="54"  width="18" height="18"/>'
        + '<rect x="-18"  width="18" height="18"/>'
        + '<rect x="-18" y="18"  width="18" height="18"/>'
        + '<rect x="-18" y="36"  width="18" height="18"/>'
        + '<rect x="-18" y="54"  width="18" height="18"/>'
        + '</g>'
        + '<g>'
        + '<rect x="0" y="0"  width="72" height="72"/>'
        + '<rect  width="18" height="18"/>'
        + '<rect y="18"  width="18" height="18"/>'
        + '<rect y="36"  width="18" height="18"/>'
        + '<rect y="54"  width="18" height="18"/>'
        + '<rect x="18"  width="18" height="18"/>'
        + '<rect x="18" y="18"  width="18" height="18"/>'
        + '<rect x="18" y="36"  width="18" height="18"/>'
        + '<rect x="18" y="54"  width="18" height="18"/>'
        + '<rect x="36"  width="18" height="18"/>'
        + '<rect x="36" y="18"  width="18" height="18"/>'
        + '<rect x="36" y="36"  width="18" height="18"/>'
        + '<rect x="36" y="54"  width="18" height="18"/>'
        + '<rect x="54"  width="18" height="18"/>'
        + '<rect x="54" y="18"  width="18" height="18"/>'
        + '<rect x="54" y="36"  width="18" height="18"/>'
        + '<rect x="54" y="54"  width="18" height="18"/>'
        + '</g>'
        + '<g>'
        + '<rect x="72" y="0"  width="72" height="72"/>'
        + '<rect x="72"  width="18" height="18"/>'
        + '<rect x="72" y="18"  width="18" height="18"/>'
        + '<rect x="72" y="36"  width="18" height="18"/>'
        + '<rect x="72" y="54"  width="18" height="18"/>'
        + '<rect x="90"  width="18" height="18"/>'
        + '<rect x="90" y="18"  width="18" height="18"/>'
        + '<rect x="90" y="36"  width="18" height="18"/>'
        + '<rect x="90" y="54"  width="18" height="18"/>'
        + '<rect x="108"  width="18" height="18"/>'
        + '<rect x="108" y="18"  width="18" height="18"/>'
        + '<rect x="108" y="36"  width="18" height="18"/>'
        + '<rect x="108" y="54"  width="18" height="18"/>'
        + '<rect x="126"  width="18" height="18"/>'
        + '<rect x="126" y="18"  width="18" height="18"/>'
        + '<rect x="126" y="36"  width="18" height="18"/>'
        + '<rect x="126" y="54"  width="18" height="18"/>'
        + '</g>'
        + '<g>'
        + '<rect x="-144" y="72"  width="72" height="72"/>'
        + '<rect x="-144" y="72"  width="18" height="18"/>'
        + '<rect x="-144" y="90"  width="18" height="18"/>'
        + '<rect x="-144" y="108"  width="18" height="18"/>'
        + '<rect x="-144" y="126"  width="18" height="18"/>'
        + '<rect x="-126" y="72"  width="18" height="18"/>'
        + '<rect x="-126" y="90"  width="18" height="18"/>'
        + '<rect x="-126" y="108"  width="18" height="18"/>'
        + '<rect x="-126" y="126"  width="18" height="18"/>'
        + '<rect x="-108" y="72"  width="18" height="18"/>'
        + '<rect x="-108" y="90"  width="18" height="18"/>'
        + '<rect x="-108" y="108"  width="18" height="18"/>'
        + '<rect x="-108" y="126"  width="18" height="18"/>'
        + '<rect x="-90" y="72"  width="18" height="18"/>'
        + '<rect x="-90" y="90"  width="18" height="18"/>'
        + '<rect x="-90" y="108"  width="18" height="18"/>'
        + '<rect x="-90" y="126"  width="18" height="18"/>'
        + '</g>'
        + '<g>'
        + '<rect x="-72" y="72"  width="72" height="72"/>'
        + '<rect x="-72" y="72"  width="18" height="18"/>'
        + '<rect x="-72" y="90"  width="18" height="18"/>'
        + '<rect x="-72" y="108"  width="18" height="18"/>'
        + '<rect x="-72" y="126"  width="18" height="18"/>'
        + '<rect x="-54" y="72"  width="18" height="18"/>'
        + '<rect x="-54" y="90"  width="18" height="18"/>'
        + '<rect x="-54" y="108"  width="18" height="18"/>'
        + '<rect x="-54" y="126"  width="18" height="18"/>'
        + '<rect x="-36" y="72"  width="18" height="18"/>'
        + '<rect x="-36" y="90"  width="18" height="18"/>'
        + '<rect x="-36" y="108"  width="18" height="18"/>'
        + '<rect x="-36" y="126"  width="18" height="18"/>'
        + '<rect x="-18" y="72"  width="18" height="18"/>'
        + '<rect x="-18" y="90"  width="18" height="18"/>'
        + '<rect x="-18" y="108"  width="18" height="18"/>'
        + '<rect x="-18" y="126"  width="18" height="18"/>'
        + '</g>'
        + '<g>'
        + '<rect x="0" y="72"  width="72" height="72"/>'
        + '<rect y="72"  width="18" height="18"/>'
        + '<rect y="90"  width="18" height="18"/>'
        + '<rect y="108"  width="18" height="18"/>'
        + '<rect y="126"  width="18" height="18"/>'
        + '<rect x="18" y="72"  width="18" height="18"/>'
        + '<rect x="18" y="90"  width="18" height="18"/>'
        + '<rect x="18" y="108"  width="18" height="18"/>'
        + '<rect x="18" y="126"  width="18" height="18"/>'
        + '<rect x="36" y="72"  width="18" height="18"/>'
        + '<rect x="36" y="90"  width="18" height="18"/>'
        + '<rect x="36" y="108"  width="18" height="18"/>'
        + '<rect x="36" y="126"  width="18" height="18"/>'
        + '<rect x="54" y="72"  width="18" height="18"/>'
        + '<rect x="54" y="90"  width="18" height="18"/>'
        + '<rect x="54" y="108"  width="18" height="18"/>'
        + '<rect x="54" y="126"  width="18" height="18"/>'
        + '</g>'
        + '<g>'
        + '<rect x="72" y="72"  width="72" height="72"/>'
        + '<rect x="72" y="72"  width="18" height="18"/>'
        + '<rect x="72" y="90"  width="18" height="18"/>'
        + '<rect x="72" y="108"  width="18" height="18"/>'
        + '<rect x="72" y="126"  width="18" height="18"/>'
        + '<rect x="90" y="72"  width="18" height="18"/>'
        + '<rect x="90" y="90"  width="18" height="18"/>'
        + '<rect x="90" y="108"  width="18" height="18"/>'
        + '<rect x="90" y="126"  width="18" height="18"/>'
        + '<rect x="108" y="72"  width="18" height="18"/>'
        + '<rect x="108" y="90"  width="18" height="18"/>'
        + '<rect x="108" y="108"  width="18" height="18"/>'
        + '<rect x="108" y="126"  width="18" height="18"/>'
        + '<rect x="126" y="72"  width="18" height="18"/>'
        + '<rect x="126" y="90"  width="18" height="18"/>'
        + '<rect x="126" y="108"  width="18" height="18"/>'
        + '<rect x="126" y="126"  width="18" height="18"/>'
        + '</g>'
        + '<line x1="0" y1="-144" x2="0" y2="144"/>'
        + '<line x1="-144" y1="0" x2="144" y2="0"/>'
        + '</g>';
    }
    else if (newDemo == "heartDemo") {

      this.newProject = "4_200_60_240_0_0.32_0_0_-7_-36_10_100_100_1_0_1_360_#heart_false_false_false_false_false_false_false_false_false_false_false_false";
      this.thing = "";
    }
    else if (newDemo == "hexagonDemo") {

      this.newProject = "4 360 258 0.46 0 0 0 0 10 100 100 1 0 5 0 #hexagon false false false false false false";
      this.thing = "";
    }
    else if (newDemo == "hueDemo") {

      this.newProject = "5_200_-1_215_0_0.01_0_0_0_0_0_100_100_1_139_1_0_#kitchen _false_false_false_false_false_false_false_false_false_false_false_false";
      this.thing = '<g><path d="M169.815,74.378L42.754-18.059C38.49-91.593,21.187-146.63,0.486-146.63c-20.701,0-38.004,55.037-42.268,128.571l-137.142,90.756l63.865-21.849h73.182C-37.781,125.224-20.371,181.1,0.487,181.1c20.858,0,38.269-55.875,42.364-130.251h68.141L169.815,74.378z"/></g>'
    }
    else if (newDemo == "leavesDemo") {

      this.newProject = "1 2 0 2 0 0 -185 85 10 100 100 1 67 5 0 #leaves false false false false false false";
      this.thing = "";
    }
    else if (newDemo == "newShapeDemo") {

      this.newProject = "6_200_60_142_5_3_58_0_0_0_10_100_100_1_0_5_360_#kitchen_false_false_false_false_false_false_false_false_false_false_false_false";
      this.thing = '<path fill="#FFFFFF" stroke="#000000" stroke-miterlimit="10" d="M178.977,422.275c28.547,31.354,115.748-124.41,184.251-99.213c68.504, 25.197 - 154.331, 146.457, 68.504, 25.197C654.566, 227, 647.48, 141.961, 654.566, 22C661.654, 312.039, 130.945, 369.52, 178.977, 422.275z"/>';

    }
    else if (newDemo == "octagonDemo") {

      this.newProject = "4 20 5 0.75 0 0 -171 0 10 100 100 1 0 5 0 #octagon false false false false false false";
      this.thing = "";
    }
    else if (newDemo == "pentagonDemo") {

      this.newProject = "4 360 0 0.6 0 0 0 0 10 100 100 1 0 0 0 #pentagon false false false false false false";
      this.thing = "";
    }
    else if (newDemo == "polyShapeDemo") {

      this.newProject = "1_0_60_1_5_2_0_0_0_0_10_100_100_1_0_5_360_#polyShape_false_false_false_false_false_false_false_false_false_false_false_false";
      this.thing = "";
    }
    else if (newDemo == "rotateDemo") {

      this.newProject = "1 2 0 1 0 0 -920 -520 0 100 100 1 0 5 0 #kitchen  false false false false false false";
      this.thing = '<path  stroke-miterlimit="10" d="M1013.295,631.886c0-68.583-27.799-130.673-72.743-175.618'
        + 'c-44.944-44.944-107.034,206.257-175.617,206.257c-69.835,0-132.939-250.177-178.063-203.777'
        + 'c-43.505,44.735-70.298,105.808-70.298,173.138c0,137.165,111.195,248.36,248.361,248.36'
        + 'C902.1,880.246,1013.295,769.051,1013.295,631.886z"/>'
        + '<polygon fill="#FFFFFF" stroke="#000000" stroke-miterlimit="10" points="789.342,879.524 755.918,287.41 721.939,879.524 '
        + '516.574,879.524 516.574,1097.246 1013.295,1097.246 1013.295,879.524 "/>';
    }
    else if (newDemo == "randomDemo") {

      this.newProject = "1 360 5 0.075 0 0 0 0 57 100 100 1 365 5 0 #shape true true true true true true";
      this.thing = "";
    }
    else if (newDemo == "nameDemo") {


      this.newProject = "1_800_600_20_18_0.48_0_0_0_0_191_45_100_1_0_0_0_#kitchen_false_false_false_false_false_false_false_false_false_false_false_false";
      this.thing = '<g transform="rotate(0,0,0) scale(8,8) skewX(0) skewY(0) translate(0,0)" ><text>Your Name Here </text>< /g>';

    }
    else if (newDemo == "squareDemo") {

      this.newProject = "1 2 0 6 0 0 -201 85 10 100 100 1 0 5 0 #square false false false false false false";
      this.thing = "";
    }
    else if (newDemo == "stickDemo") {

      this.newProject = "1 200 1 0.011 0 0 -200 200 10 100 100 1 0 1 0 #stick true true true true false false";
      this.thing = "";
    }
    else if (newDemo == "triangleDemo") {

      this.newProject = "3 360 68 1 0 0 9 -23 10 100 100 0.17 365 1 0 #triangle false false false false false false";
      this.thing = "";
    }
    else if (newDemo == "xyDemo") {

      this.newProject = "1 2 0 1.7 0 0 -200 200 10 100 100 1 0 5 0 #kitchen  false false false false false false";
      this.thing = '<polygon  stroke="#FFFFFF" stroke-miterlimit="10" points="486,2.23 414,-33.77 414,-2.884 6.95,-2.884 6.95,-409.541 38.229,-409.541 2.229,-481.541 -33.771,-409.541 -2.885,-409.541 -2.885,-2.884 -481.541,-2.884 -481.541,6.951 -2.885,6.951 -2.885,486 6.95,486 6.95,6.951 414,6.951 414,38.23 "/>';
    }
    else if (newDemo == "zoomDemo") {

      this.newProject = "1 2 0 1 0 0 -920 -520 10 100 100 1 0 5 0 #kitchen  false false false false false false";
      this.thing = '<g>'
        + '<rect fill="none" stroke="#EE1C4F" stroke-width="5" stroke-miterlimit="10" width="1440" height="1440"/>'
        + '<rect x="72" y="72" fill="none" stroke="#EE1C4F" stroke-width="5" stroke-miterlimit="10" width="1296" height="1296"/>'
        + '<rect x="136.8" y="136.8" fill="none" stroke="#EE1C4F" stroke-width="5" stroke-miterlimit="10" width="1166.4" height="1166.4"/>'
        + '<rect x="195.12" y="195.12" fill="none" stroke="#EE1C4F" stroke-width="5" stroke-miterlimit="10" width="1049.76" height="1049.76"/>'
        + '<rect x="247.608" y="247.608" fill="none" stroke="#EE1C4F" stroke-width="5" stroke-miterlimit="10" width="944.784" height="944.784"/>'
        + '<rect x="294.847" y="294.847" fill="none" stroke="#EE1C4F" stroke-width="5" stroke-miterlimit="10" width="850.305" height="850.305"/>'
        + '<rect x="337.362" y="337.362" fill="none" stroke="#EE1C4F" stroke-width="5" stroke-miterlimit="10" width="765.274" height="765.274"/>'
        + '<rect x="375.626" y="375.626" fill="none" stroke="#EE1C4F" stroke-width="5" stroke-miterlimit="10" width="688.747" height="688.747"/>'
        + '<rect x="410.063" y="410.063" fill="none" stroke="#EE1C4F" stroke-width="5" stroke-miterlimit="10" width="619.872" height="619.872"/>'
        + '<rect x="441.057" y="441.057" fill="none" stroke="#EE1C4F" stroke-width="5" stroke-miterlimit="10" width="557.885" height="557.885"/>'
        + '<rect x="468.952" y="468.952" fill="none" stroke="#EE1C4F" stroke-width="5" stroke-miterlimit="10" width="502.096" height="502.096"/>'
        + '<rect x="494.057" y="494.057" fill="none" stroke="#EE1C4F" stroke-width="5" stroke-miterlimit="10" width="451.887" height="451.887"/>'
        + '<rect x="516.651" y="516.651" fill="none" stroke="#EE1C4F" stroke-width="5" stroke-miterlimit="10" width="406.698" height="406.698"/>'
        + '<rect x="536.986" y="536.986" fill="none" stroke="#EE1C4F" stroke-width="5" stroke-miterlimit="10" width="366.028" height="366.028"/>'
        + '<rect x="555.287" y="555.287" fill="none" stroke="#EE1C4F" stroke-width="5" stroke-miterlimit="10" width="329.425" height="329.425"/>'
        + '<rect x="571.758" y="571.758" fill="none" stroke="#EE1C4F" stroke-width="5" stroke-miterlimit="10" width="296.482" height="296.482"/>'
        + '<rect x="586.583" y="586.583" fill="none" stroke="#EE1C4F" stroke-width="5" stroke-miterlimit="10" width="266.833" height="266.833"/>'
        + '<rect x="599.924" y="599.924" fill="none" stroke="#EE1C4F" stroke-width="5" stroke-miterlimit="10" width="240.15" height="240.15"/>'
        + '<rect x="611.932" y="611.932" fill="none" stroke="#EE1C4F" stroke-width="5" stroke-miterlimit="10" width="216.135" height="216.135"/>'
        + '<rect x="622.738" y="622.738" fill="none" stroke="#EE1C4F" stroke-width="5" stroke-miterlimit="10" width="194.521" height="194.521"/>'
        + '<rect x="632.464" y="632.464" fill="none" stroke="#EE1C4F" stroke-width="5" stroke-miterlimit="10" width="175.069" height="175.069"/>'
        + '<rect x="641.218" y="641.218" fill="none" stroke="#EE1C4F" stroke-width="5" stroke-miterlimit="10" width="157.562" height="157.562"/>'
        + '<rect x="649.096" y="649.096" fill="none" stroke="#EE1C4F" stroke-width="5" stroke-miterlimit="10" width="141.806" height="141.806"/>'
        + '<rect x="656.186" y="656.186" fill="none" stroke="#EE1C4F" stroke-width="5" stroke-miterlimit="10" width="127.625" height="127.625"/>'
        + '<rect x="662.567" y="662.567" fill="none" stroke="#EE1C4F" stroke-width="5" stroke-miterlimit="10" width="114.863" height="114.863"/>'
        + '<rect x="668.311" y="668.311" fill="none" stroke="#EE1C4F" stroke-width="5" stroke-miterlimit="10" width="103.377" height="103.377"/>'
        + '<rect x="673.479" y="673.479" fill="none" stroke="#EE1C4F" stroke-width="5" stroke-miterlimit="10" width="93.039" height="93.039"/>'
        + '<rect x="678.131" y="678.131" fill="none" stroke="#EE1C4F" stroke-width="5" stroke-miterlimit="10" width="83.735" height="83.735"/>'
        + '<rect x="682.318" y="682.318" fill="none" stroke="#EE1C4F" stroke-width="5" stroke-miterlimit="10" width="75.361" height="75.361"/>'
        + '<rect x="686.086" y="686.086" fill="none" stroke="#EE1C4F" stroke-width="5" stroke-miterlimit="10" width="67.825" height="67.825"/>'
        + '<rect x="689.478" y="689.478" fill="none" stroke="#EE1C4F" stroke-width="5" stroke-miterlimit="10" width="61.042" height="61.042"/>'
        + '</g>';
    }
    console.log("newProject=" + this.newProject);
    console.log("thing=" + this.thing);
    //document.getElementById("kitchen").innerHTML = this.thing;
    this.showData = this.thing;
    this.pasteArtDataString = this.newProject + "@" + this.thing;
    //this.processsvgobject(this.pasteArtDataString);
    this.processArtData(this.pasteArtDataString);
    name = './assets/presethtml/' + newDemo + '.html';
    this.usechallenge = true;
    var mylesson = '<object  data = "' + name + '" width="500px" height="700px"> </object>';
    //alert(name);
    document.getElementById("lesson").innerHTML = mylesson;

    /*
    console.log("name=" + name);
    var settings = "resizable=yes,width=" + 500 + ",height=" + 700;
    var mywindow = window.open(name, "MathArt Challenges", settings);
    mywindow.moveTo(2020, 0);
*/
  }
  private cleanThis(thisstring) {
    thisstring.replace(/\r\n/, "");
    return thisstring;
  }
  private bigart() {
    this.stageSize = 5000;
  }
  private exportArt() {
    this.bigart();
    this.saveArtData();
    this.downloadArt('playspace');
  }


  private normalart() {
    this.stageSize = 500;
  }




}
